import React, {useEffect } from 'react';
const LinkItem = ({linkItemData, parentFunction, crumbsFunction, animation, setRightAni, teaserDataCallback, activePageId, tabIndex, firstFlyoutLinkRef, focusFirstFlyoutLink, dictionary}:any) => {

  // check if item has children
  const checkIfLinkItemHasChildren = (e:any, data:any) => {
    if(data.children){
      e.preventDefault();
      // check for teaser
      if(data.teaser){
        teaserDataCallback(data.teaser);
      }else{
        teaserDataCallback({});
      }

      parentFunction(data.children);
      crumbsFunction(data);
      // Let the Linkitems fade from right to left
      setRightAni();
      return true;
    }
    return false;
  }

  const setListElementHeight = () => {
    // get li items by classname
    const list = document.querySelectorAll('#main-navigation .nav__item');
    let localHeighestHight = 0;

    if(list.length > 1){
      // get li elements heighest value
      list.forEach(
        (element:any) => {
          // reset element height
          element.style.height = 'auto';

          // get element height
          const {height} = element.getBoundingClientRect();

          // check element height
          if(height > localHeighestHight){
            localHeighestHight = height;
          }
        }
      );

      // set li elements height value
      list.forEach(
        (element:any) => {
          element.style.height = localHeighestHight + 'px';
        }
      );
    }
  }

  useEffect(() => {
    // register li element resize & trigger first use
    window.addEventListener('resize', setListElementHeight);
    setListElementHeight();
    focusFirstFlyoutLink();

  }, [linkItemData]);

  // fallback if no items
  if(linkItemData === undefined){
    return <ul/>;
  }


  // check for html soft hyphen and set them to unicode
  const getItemLabel = (textRef:string) => {
    if(textRef !== undefined){
      textRef = textRef.replaceAll('&shy;', '\u00AD');
    }
    return textRef;
  };

  return (
    <>
      {linkItemData.map((item:any, key:any) => (
        <li
          key={item.id}
          className={`${item.isOverview === true ? "bold " : ""}${(activePageId === item.id) ? "active " : ""}nav__item animate__animated ` + animation}
        >
          <a
            ref={key === 0 ? firstFlyoutLinkRef : null}
            className="nav__link js-nav-link"
            data-id={item.id}
            aria-haspopup={!item.children ? 'false' : 'true'}
            role={!item.children ? 'link' : 'button'}
            href={!item.children ? item.url : '#'}
            onClick={(event) => checkIfLinkItemHasChildren(event, item)}
            tabIndex={tabIndex}
          >
            <span className="title-wrap" >
              <span className="nav__title">
                {
                  item.programNumber &&
                    <span className={`${item.programType === 'credit' ? "credit" : "benefit"} nav__program`}>
                      <span className="a11y-hidden">Produkt</span>
                      {item.programNumber}
                    </span>
                }
                <span className="title-text">
                  {getItemLabel(item.headline)}
                </span>
                {
                  linkItemData && item.unlocked === false ?
                    <span className="ic-lock" aria-label={dictionary["nav.loginrequired"] || "Anmeldung erforderlich"} />:''
                }
                {
                  linkItemData && item.unlocked === true ?
                    <span className="ic-unlock" aria-hidden="true" />:''
                }
                {
                  linkItemData && item.children ?
                    <span className="ic-arrowRight" aria-hidden="true" />:''
                }
              </span>
              <span className="nav__subline">
                {item.subline}
              </span>
            </span>
          </a>
        </li>
      ))}
    </>
  )
};

export default LinkItem;
